import {
  map as _map,
  isFunction as _isFunction,
  isNil as _isNil,
  forEach as _forEach,
  toLower as _toLower,
} from 'lodash';

import { findAndGet } from '@vfgroup-oneplatform/framework/Services/Utils/Utils';

const mapLicences = licences => {
  return _map(licences, item => {
    const licence = {
      id: item.id,
      description: item.description,
      name: item.name,
      status: item.status,
    };
    const licenseKey = findAndGet(item.productCharacteristic, 'name', 'LicenseKey', 'value');
    if (!_isNil(licenseKey)) {
      licence.licenseKey = licenseKey;
    }
    return licence;
  });
};

export const mapApplications = (response, iconsMapper, imagesMapper) => {
  return _map(response, application => {
    const {
      id,
      description,
      name,
      product: _product,
      productCharacteristic,
      category,
      status,
      productPrice,
    } = application;
    const { unitOfMeasure, recurringChargePeriod, price: _price } = productPrice[0];
    const price = {
      unitOfMeasure,
      recurringPeriod: recurringChargePeriod,
      currency: _price?.taxIncludedAmount?.unit,
      value: parseFloat(_price?.taxIncludedAmount?.value).toFixed(2),
    };
    const mappedApplication = {
      id,
      description,
      name,
      category,
      status,
      price,
      licences: mapLicences(_product),
    };
    if (_isFunction(iconsMapper)) {
      mappedApplication.icon = iconsMapper(id);
    }
    if (_isFunction(imagesMapper)) {
      mappedApplication.image = imagesMapper(id);
    }
    const number = findAndGet(productCharacteristic, 'name', 'Number', 'value');
    if (!_isNil(number)) {
      mappedApplication.number = number;
    }
    return mappedApplication;
  });
};

export const getTotalLicenceCount = (applications, status) => {
  let count = 0;
  _forEach(applications, app => {
    const { licences } = app;
    _forEach(licences, licence => {
      if (_isNil(status) || _toLower(licence.status) === _toLower(status)) {
        count++;
      }
    });
  });
  return count;
};
